import { render, staticRenderFns } from "./data-user-sidebar.vue?vue&type=template&id=a9cf1b82&scoped=true&"
import script from "./data-user-sidebar.component.ts?vue&type=script&lang=ts&"
export * from "./data-user-sidebar.component.ts?vue&type=script&lang=ts&"
import style0 from "./data-user-sidebar.vue?vue&type=style&index=0&id=a9cf1b82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cf1b82",
  null
  
)

export default component.exports